function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = form => {
  const obj = {};
  const formData = new FormData(form);

  for (const key of formData.keys()) {
    const regex = /(?:^(properties\[))(.*?)(?:\]$)/;

    if (regex.test(key)) {
      obj.properties = obj.properties || {};
      obj.properties[regex.exec(key)[2]] = formData.get(key);
    } else {
      obj[key] = formData.get(key);
    }
  }

  return JSON.stringify(obj);
};

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    const summaryElements = this.querySelectorAll('summary');
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    const navClose = document.querySelector('.mobile-close');

    navClose.addEventListener('click', this.navClose.bind(this))
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  navClose(event) {
    const mobilenav = document.querySelector('.header-nav-container');
    const header = document.getElementById('shopify-section-header');

    header.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
      details.querySelector('summary').setAttribute('aria-expanded', false);
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(false);
    this.closeAnimation(header.querySelector('details'));

    mobilenav.classList.remove('nav-open');
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach(element => {
      element.setAttribute('role', 'button');
      element.setAttribute('aria-expanded', false);
      element.setAttribute('aria-controls', 'header-nav-container');
    });
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');
    const mobilenav = document.querySelector('.header-nav-container');

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) {
        mobilenav.classList.remove('nav-open');
      } else {
        mobilenav.classList.add('nav-open');
      }
      isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));

      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    if (this.querySelector('.js-quick-add-close')) {
      this.querySelector('.js-quick-add-close').addEventListener(
        'click',
        this.hide.bind(this, false)
      );
    }
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.style.top = '-' + document.documentElement.scrollTop + 'px';
    document.body.classList.add('better-overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');
    const jsCardQuickView = this.querySelector('.js-card-product-modal');
    const cardAll = document.querySelectorAll('.js-card-product-modal');

    if (button) {
      button.addEventListener('click', () => {
        const modal = document.querySelector(this.getAttribute('data-modal'));
        if (modal) modal.show(button);
      });
    }

    if (jsCardQuickView) {
      jsCardQuickView.addEventListener('click', (event) => {
        const modal = document.querySelector(this.getAttribute('data-modal')); console.log(modal);

        cardAll.forEach((cardCell) => {
          cardCell.classList.remove('active');
        })
        jsCardQuickView.classList.add('active');
        if (modal) modal.show(jsCardQuickView);
      })
    }
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    if (poster.classList.contains('no_poster')) {
      this.checkIfVideoInView = this.checkIfVideoInView.bind(this);
      document.addEventListener('scroll', this.checkIfVideoInView);
    } else {
      poster.addEventListener('click', this.loadContent.bind(this));
    }
  }

  checkIfVideoInView() {
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    const posterBoundingClientRect = poster.getBoundingClientRect();
    const top = posterBoundingClientRect.top - 50;
    const bottom = posterBoundingClientRect.bottom + 50;
    const posterInView = top <= window.innerHeight && bottom >= 0;
    if (posterInView) {
      this.loadContent();
      this.removeVideoListener();
    }
  }

  removeVideoListener(el) {
    document.removeEventListener('scroll', this.checkIfVideoInView);
  }

  loadContent() {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();

      const ad = this.closest('.card-wrapper__ad');
      if (!ad) return;
      ad.classList.add('video-loaded');
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('ul');
    this.sliderItems = this.querySelectorAll('li');
    this.sliderDots = this.querySelector('.slider-dots');
    this.pageCount = this.querySelector('.slider-counter--current');
    this.pageTotal = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.firstSlide = this.sliderItems[0];
    this.lastSlide = this.sliderItems[0];
    this.index = 0;
    this.fixedOffset = 0;

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));

    if (this.sliderDots) {
      this.sliderDot = this.sliderDots.querySelectorAll('div')
      this.sliderDots.addEventListener('click', this.onDotClick.bind(this));
    }
  }

  initPages() {
    const sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    this.sliderLastItem = sliderItemsToShow[sliderItemsToShow.length - 1];
    if (sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / sliderItemsToShow[0].clientWidth);
    this.totalPages = sliderItemsToShow.length - this.slidesPerPage + 1;

    this.lastSlide = this.sliderItems[this.totalPages - 1];

    if (!this.slider.classList.contains('loaded')) {
      const cloneFirst = this.firstSlide.cloneNode(true);
      const cloneLast = this.lastSlide.cloneNode(true);

      cloneFirst.classList.add('cloned');
      cloneLast.classList.add('cloned');

      this.slider.appendChild(cloneFirst);
      this.slider.insertBefore(cloneLast, this.firstSlide);
      this.slider.classList.add('loaded');
    }

    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPage > this.totalPages) {
      this.currentPage = 1;
    }
    if (this.currentPage == 1) {
      $(".slider-dots--show").removeClass('current')
      $(".slider-dots--show:eq(0)").addClass('current')
    }
    if (this.currentPage == 2) {
      $(".slider-dots--show").removeClass('current')
      $(".slider-dots--show:eq(1)").addClass('current')
    }
    if (this.currentPage == 3) {
      $(".slider-dots--show").removeClass('current')
      $(".slider-dots--show:eq(2)").addClass('current')
    }
    if (this.currentPage == 4) {
      $(".slider-dots--show").removeClass('current')
      $(".slider-dots--show:eq(3)").addClass('current')
    }
    if (this.currentPage == 5) {
      $(".slider-dots--show").removeClass('current')
      $(".slider-dots--show:eq(4)").addClass('current')
    }
    if (this.index === 1) {

      // this.prevButton.setAttribute('disabled', true);
    } else {
      // this.prevButton.removeAttribute('disabled');

    }

    if (this.index === this.totalPages) {
      // this.nextButton.setAttribute('disabled', true);
    } else {
      // this.nextButton.removeAttribute('disabled');
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;

    if (!this.sliderDots) return;

    var lis = this.sliderDots.querySelectorAll('div'),
      visible_slides = Array.from(this.sliderItems).filter(s =>
        window.getComputedStyle(s).getPropertyValue('display') != 'none'
      );
    [].forEach.call(lis, function (el) {
      el.classList.remove('slider-dots--show');
    });
    for (var i = 0; i < visible_slides.length; i++) {


      lis[i].classList.add('slider-dots--show');

    }
  }

  onScroll() {
    if (this.slider.scrollLeft.toFixed() === this.fixedOffset) {
      if (this.index < 0 || this.index == this.totalPages) {
        console.log
        let goTo = this.sliderLastItem.clientWidth;
        let newIndex = 0;
        if (this.index < 0) {
          goTo = this.sliderLastItem.clientWidth * this.totalPages;
          newIndex = this.totalPages - 1;
        }
        this.slider.style.scrollBehavior = 'auto';
        this.index = newIndex;
        this.slider.scrollTo({
          left: goTo
        })
        this.slider.style.removeProperty('scroll-behavior');
      }
      this.slider.removeEventListener('scroll', this.onScroll);
    }

    if (!this.sliderDots) return;

    [].forEach.call(this.sliderDot, function (el) {
      el.classList.remove('current');

    });
    this.sliderDot[this.index].classList.add('current');
  }

  scrollToSlide(offset) {
    this.fixedOffset = offset.toFixed();
    this.slider.addEventListener('scroll', this.onScroll.bind(this));
    this.onScroll();
    this.slider.scrollTo({
      left: offset
    })
  }

  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + this.sliderLastItem.clientWidth : this.slider.scrollLeft - this.sliderLastItem.clientWidth;
    this.index = event.currentTarget.name === 'next' ? this.index += 1 : this.index -= 1;
    this.scrollToSlide(slideScrollPosition);
  }

  onDotClick(event) {
    var visible_slides = Array.from(this.sliderItems).filter(s =>
      window.getComputedStyle(s).getPropertyValue('display') != 'none'
    );
    this.index = event.target.textContent;
    this.scrollToSlide(visible_slides[event.target.textContent].clientWidth * event.target.textContent);
  }
}

customElements.define('slider-component', SliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.hideConditional();
  }

  onVariantChange() {

    this.updateOptions();
    this.updateMasterId();
    this.updateMetafields();
    //this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateDisabledOptions();
    this.hideConditional();


    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateSkuinfo();
      this.updateMedia();
      this.updateURL();
      //this.updateOptionText();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateCustomInputs();
    }
    this.outOfStock();
  }
  hideConditional() {

    var option1 = $('variant-radios fieldset.product-form__input[data-option="option1"]').find("input:checked").val();
    var option1_remove = '';
    if (option1) {
      option1_remove = option1.replace(/'/g, '').replace(/"/g, '');
    }
    console.log('option1_remove', option1_remove);

    var wxVariantSelect = $("select.variants-wx-select");

    var disallowFdrVariantElements = $('select.variants-wx-select option[data-disallow_fdr="true"]');
    var disallowFdrOption = '';
    if (disallowFdrVariantElements.length == 1) {
      var disallowFdrTitleFinal = disallowFdrVariantElements.attr('data-titlefinal');
      if (disallowFdrTitleFinal !== '') {
        var parts = disallowFdrTitleFinal.split('/');
        if (parts.length > 0) {
          disallowFdrOption = parts[0].trim() + ' /';
        }
      }
    }

    var checkedValues = $('variant-radios fieldset.product-form__input input:checked').map(function () {
      return $(this).val();
    }).get();
    var allCheckedValues = checkedValues.join(" / ").replace(/'/g, '').replace(/"/g, '');
    //console.log(allCheckedValues);

    var disallowFdr = wxVariantSelect.find("option[data-titlefinal='" + allCheckedValues + "']").data('disallow_fdr');
    ///console.log(disallowFdr)
    if (disallowFdr) {
      $('.see-deisgn-mock-area').addClass('disabled');
      this.setUnavailable();
    } else {
      $('.see-deisgn-mock-area').removeClass('disabled');
      $('.product-form__submit.button').prop('disabled', false);
      $('.product-form__submit.button').html('Add to cart');
      if (disallowFdrOption !== '') {
        if (allCheckedValues.includes(disallowFdrOption)) {
          $('.see-deisgn-mock-area,.quick-add-modal-form-submit').addClass('disabled');
          this.setUnavailable();
        }
      }
    }

    $('.thumbnail-change-slider').addClass('activeSlider');

    var towOptions = $('variant-radios fieldset.product-form__input[data-option="option1"] input:checked,variant-radios fieldset.product-form__input[data-option="option2"] input:checked').map(function () {
      return $(this).val();
    }).get();
    var CheckedtowOptions = towOptions.join(" / ").replace(/'/g, '').replace(/"/g, '');
    console.log(CheckedtowOptions);


    var threeOptions = $('variant-radios fieldset.product-form__input[data-option="option1"] input:checked,variant-radios fieldset.product-form__input[data-option="option2"] input:checked,variant-radios fieldset.product-form__input[data-option="option3"] input:checked').map(function () {
      return $(this).val();
    }).get();
    var CheckedthreeOptions = threeOptions.join(" / ").replace(/'/g, '').replace(/"/g, '');
    console.log(CheckedthreeOptions);


    if ($('.thumbnail-change-slider .thumbnail-list__item.spltCount3[data-final-alt="' + CheckedthreeOptions + '"]').length > 0) {
      console.log('all values 3nd level: true');
      $('.thumbnail-change-slider .thumbnail-list__item:not(.donthideit)').removeClass('showimage').hide();
      $('.thumbnail-change-slider .thumbnail-list__item[data-final-alt="' + CheckedthreeOptions + '"]').addClass('showimage').show();

    } else {

      if ($('.thumbnail-change-slider .thumbnail-list__item[data-final-alt="' + CheckedtowOptions + '"]').length > 0) {

        console.log('all values 2nd level: true');
        $('.thumbnail-change-slider .thumbnail-list__item:not(.donthideit)').removeClass('showimage').hide();
        $('.thumbnail-change-slider .thumbnail-list__item[data-final-alt="' + CheckedtowOptions + '"]').addClass('showimage').show();

      } else {

        if ($('.thumbnail-change-slider .thumbnail-list__item[data-alt="' + option1_remove + '"]').length > 0) {
          console.log('all values: false');
          $('.thumbnail-change-slider .thumbnail-list__item:not(.donthideit)').removeClass('showimage').hide();
          $('.thumbnail-change-slider .thumbnail-list__item[data-alt="' + option1_remove + '"]').addClass('showimage').show();
        }

      }
    }




    if (option1 != '') {

      var occurances = 0;
      var occurancess = 0;
      var option2Checked = $('variant-radios fieldset.product-form__input[data-option="option2"]').find("input:checked");
      var option3Checked = $('variant-radios fieldset.product-form__input[data-option="option3"]').find("input:checked").val();

      // First check option2 availability based on option1
      $('variant-radios fieldset.product-form__input[data-option="option2"] label').each(function () { // loop option 2
        if ($('variant-radios fieldset.product-form__input[data-option="option2"]').hasClass('color')) {
          var option2 = $(this).prev('input').val();
        } else {
          var option2 = $(this).text().trim();
        }
        var option2Elem = $(this);

        // Check if this option2 is available with selected option1
        var variantTitle = `${option1} / ${option2}`;
        variantTitle = variantTitle.replaceAll("'", "").replaceAll('"', "");
        var length = wxVariantSelect.find("option[data-titlefinal^='" + variantTitle + "']").length;

        if (length > 0) {
          $(this).prev('input').addClass('activeVariant-input');
          $(this).addClass('activeVariant').show();
          $(this).prev('input').removeAttr('disabled');
        } else {
          $(this).prev('input').removeClass('activeVariant-input');
          $(this).prev('input').attr('disabled', 'disabled');
        }
      });

      if (option2Checked.length) {
        option2Checked.next('label').each(function () { // loop option 2
          if ($('variant-radios fieldset.product-form__input[data-option="option2"]').hasClass('color')) {
            var option2 = $(this).prev('input').val();
          } else {
            var option2 = $(this).text().trim();
          }
          var option2Elem = $(this);

          $('variant-radios fieldset.product-form__input[data-option="option3"] label').each(function () { // loop option 3
            var option3 = $(this).prev('input').val();
            var variantTitle = `${option1} / ${option2} / ${option3}`;
            variantTitle = variantTitle.replaceAll("'", "").replaceAll('"', "");
            var length = wxVariantSelect.find("option[data-titlefinal='" + variantTitle + "']").length;
            if (length > 0) {
              occurances++;
              $(this).attr("data-occurances", occurances);
              option2Elem.attr("data-occurances", occurances);
              $(this).prev('input').addClass('activeVariant-input');
              $(this).addClass('activeVariant').show();
            } else {
              $(this).prev('input').removeClass('activeVariant-input');
              // $(this).removeClass('activeVariant').hide();
              $(this).prev('input').attr('disabled', 'disabled');
            }
          });
        });
      }
    }
  }
  outOfStock() {
    $('.product__info-wrapper .product-form__input input[type=radio]').remove('disabled', 'disabled');
    if (this.currentVariant && this.currentVariant.available == false) {
      $('.product__info-wrapper .product-form__input input[type=radio]:checked').attr('disabled', 'disabled');
    }
  }
  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMetafields() {
    if (!this.parentElement.querySelector('#pro-metafields')) return;
    const metafieldData = JSON.parse(this.parentElement.querySelector('#pro-metafields').textContent);
    this.currentVariantMetafield = metafieldData.find((variant) => variant.id === this.currentVariant.id);
  }

  updateMedia() {
    console.log('updateMedia');
    console.log(this.dataset.pacdoraImageLock);
    if (this.dataset.pacdoraImageLock == "true") {
      return;
    }
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const parentId = this.dataset.section;
    const gallerySlider = $('#Slider-Gallery-' + parentId);
    var gallerySliderVideo = $('.thumbnail-change-slider .thumbnail-list__item-video').length;
    if (gallerySliderVideo > 0) {
      var mediaPositionCount = 1;
    } else {
      var mediaPositionCount = 0;
    }
    const mediaPosition = this.currentVariant.featured_image.position - mediaPositionCount;

    const datamediaPosition = mediaPosition + 1;
    if (productMediaWrapper) {
      productMediaWrapper.change_gallery_position(gallerySlider, mediaPosition);
    }

    window.setTimeout(() => {
      if (document.getElementById('BIS_trigger')) {
        if (this.currentVariant.available) {
          document.getElementById('BIS_trigger').style.display = 'none';
          $('#BIS_trigger').hide(); // hide the button
        } else {
          document.getElementById('BIS_trigger').style.display = 'block'; // show the button and set the default variant
        }
      }
    });
  }

  updateURL() {
    if (!this.currentVariant) return;
    var historyPrams = '';

    if (this.currentVariant.options.length) {
      var productJson = JSON.parse(document.querySelector('#ProductJSON-' + this.dataset.section).textContent);
      var vOptions = this.options;
      var pOptionsNames = productJson.options;

      if (vOptions.length == 2) {
        if (pOptionsNames[0] == 'Size') {
          historyPrams = `?variant=${vOptions[1]}&size=${vOptions[0]}`;
        } else {
          historyPrams = `?variant=${vOptions[0]}&size=${vOptions[1]}`;
        }
      } else if (vOptions.length == 1) {
        if (pOptionsNames[0] == 'Size') {
          historyPrams = `?size=${vOptions[0]}`;
        } else {
          historyPrams = `?variant=${vOptions[0]}`;
        }
      }
    }
    window.history.replaceState({}, '', `${window.location.pathname}${historyPrams}`);
  }

  updateOptionText() {
    if (!this.querySelector('input:checked')) return;
    const inputs = this.querySelectorAll('input:checked');

    inputs.forEach((option, index) => {
      const wrap = option.closest('.product-form__input');
      const legend = wrap.querySelector('legend');
      const inputValue = option.value;
      if (!legend) return;

      const formLabelSpan = legend.querySelector('span');
      if (formLabelSpan) formLabelSpan.innerText = inputValue;
    })
  }

  updateDisabledOptions() {


    const option1Fieldset = this.querySelector('fieldset[data-option="option1"]');
    const option2Fieldset = this.querySelector('fieldset[data-option="option2"]');
    const option3Fieldset = this.querySelector('fieldset[data-option="option3"]');
    if (option1Fieldset && option2Fieldset) {
      var option1Inputs = option1Fieldset.querySelectorAll('input');
      for (var i = 0; i < option1Inputs.length; i++) {
        //option1Inputs[i].disabled = true;
        //option1Inputs[i].setAttribute('data-availability','false');
      }
    }
    if (option2Fieldset) {
      var option2Inputs = option2Fieldset.querySelectorAll('input');
      for (var i = 0; i < option2Inputs.length; i++) {
        option2Inputs[i].disabled = true;
        option2Inputs[i].setAttribute('data-availability', 'false');
      }
    }
    if (option3Fieldset) {
      var option3Inputs = option3Fieldset.querySelectorAll('input');
      for (var i = 0; i < option3Inputs.length; i++) {
        option3Inputs[i].disabled = true;
        option3Inputs[i].setAttribute('data-availability', 'false');
      }
    }
    this.options.forEach((option, index) => {
      var curr_option = option,
        curr_option_index = 'option' + (index + 1),
        matching_variants = this.getVariantData().filter(function (element, index) {
          return element[curr_option_index] == curr_option;
        });
      let option1 = matching_variants.map(a => a.option1);
      let option2 = matching_variants.map(a => a.option2);
      let option3 = matching_variants.map(a => a.option3);
      switch (index) {
        case 0:
          if (!option2Fieldset) return;
          this.variantExistsCheck(option2Inputs, option2);
          if (!option3Fieldset) return;
          this.variantExistsCheck(option3Inputs, option3);
          break;
        case 1:
          if (!option1Fieldset) return;
          this.variantExistsCheck(option1Inputs, option1);
          if (!option3Fieldset) return;
          this.variantExistsCheck(option3Inputs, option3);
          break;
        case 2:
          if (!option1Fieldset) return;
          this.variantExistsCheck(option1Inputs, option1);
          if (!option2Fieldset) return;
          this.variantExistsCheck(option2Inputs, option2);
      }
    });
  }

  updateSkuinfo() {
    const parent = document.querySelector(`#ProductInfo-${this.dataset.section}`);
    if (!parent) return;
    parent.querySelector('.js-variant-sku').innerText = 'Sku: ' + this.currentVariant.sku + '';
    document.querySelector('.js-variant-weight').innerText = 'Weight: ' + Math.round(this.currentVariant.weight / 453.6) + ' lb';
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      var Vtitle = this.currentVariant.title;
      input.value = this.currentVariant.id;

      var fdrWrap = $('#fdr-wrap:not(.disabled) a').data('productv');
      if (fdrWrap == true) {
        var hrf = $('#fdr-wrap:not(.disabled) a').data('href');
        $('#fdr-wrap:not(.disabled) a').attr('href', hrf + '&variant=' + this.currentVariant.id);
      }


      input.setAttribute("data-price", this.currentVariant.price);
      $('.price--large .price-item--regular,.product_price .append-price-item').text(Shopify.formatMoney(this.currentVariant.price).replace(/((\,00)|(\.00))$/g, ''));
      input.dispatchEvent(new Event('change', { bubbles: true }));

      if (Vtitle.includes("Frame Only")) {
        document.querySelector('.product__info-wrapper').classList.add('hide-art');
      } else {
        document.querySelector('.product__info-wrapper').classList.remove('hide-art');
      }

      if (!this.currentVariantMetafield) return;
      const currentVariantMetafieldKeys = Object.keys(this.currentVariantMetafield.metafields);
      currentVariantMetafieldKeys.forEach((level) => {
        if (productForm.querySelector(`input[name="properties[_price-${level}]"]`)) {
          productForm.querySelector(`input[name="properties[_price-${level}]"]`).value = this.currentVariantMetafield.metafields[level];
        }
      });
    });
  }

  updateCustomInputs() {
    if (!this.currentVariant) return;
    const cvId = this.currentVariant.id;

    $('.product-form__addon--capsule').attr('data-target', `#product-modal-${cvId}-addons`);
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    productForm.product_price_update();
    productForm.product_installment_update();
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {

        const priceid = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(priceid);
        const source = html.getElementById(priceid);

        const addonId = `product-form__addon-${this.dataset.section}`;
        const addondestination = document.getElementById(addonId);
        const addonsource = html.getElementById(addonId);

        const customSelector = `gf-product-custom-selector-${this.dataset.section}`;
        const customSelectordestination = document.getElementById(customSelector);
        const customSelectorsource = html.getElementById(customSelector);
        const finalcustomSelectorsource = html.querySelector('.gf-product-custom-selector-final .product-custom-upload .product-custom-upload__file-wrapper');
        const finalcustomSelector = document.querySelector('.gf-product-custom-selector-final .product-custom-upload .product-custom-upload__file-wrapper');

        console.log('responseText', finalcustomSelectorsource);
        const uploaderWrap = html.querySelector('.product-custom-upload__upload-wrapper');

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (addondestination && addonsource) { addondestination.innerHTML = addonsource.innerHTML; }
        if (customSelectordestination && customSelectorsource) customSelectordestination.innerHTML = customSelectorsource.innerHTML;
        setTimeout(() => {
          console.log('testog   ')
          if (finalcustomSelector && finalcustomSelectorsource) finalcustomSelector.innerHTML = finalcustomSelectorsource.innerHTML;
          // if (uploaderWrap){window.Cloudlift.upload.App.setup();}
        }, 100);


        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const klayvioTrigger = productForm.querySelector('.klaviyo-bis-trigger');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', true);
      if (text) {
        addButton.textContent = text;
        //addButton.style.display = 'none';
        //klayvioTrigger.classList.remove('hide');
      } else {
        //addButton.style.display = 'block';
        //klayvioTrigger.classList.add('hide');
      }
    } else {
      addButton.removeAttribute('disabled');
      addButton.textContent = window.variantStrings.addToCart;
      //addButton.style.display = 'block';
      //klayvioTrigger.classList.remove('hide');
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    if (window.variantStrings) {
      addButton.textContent = window.variantStrings.unavailable;
    }
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  variantExistsCheck(inputs, options) {
    for (var i = 0; i < inputs.length; i++) {
      if (options.includes(inputs[i].value)) {
        inputs[i].disabled = false;
        inputs[i].setAttribute('data-availability', 'true');
      }
    }
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      const checkedInput = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked);
      return checkedInput ? checkedInput.value : null;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

// WICK SPECIFIC FUNCTIONALITY

function serializeJSON(form) {
  const formData = new FormData(form);
  const pairs = {}
  const consistent = {};
  for (const [name, value] of formData) {
    if (value === null || value === '' || JSON.stringify(value) === '{}') {
      continue
    } else if (name == 'form_type' || name == 'utf8') {
      consistent[name] = value;
    } else {
      pairs[name] = value;
    }
  }
  return JSON.stringify({ consistent, data: pairs }, null, 2);
}

class FormBuilder extends HTMLElement {
  constructor() {
    super();
    this.form = document.querySelector('#warranty-form');
    this.thanks = document.querySelector('#thanks');
    this.form_submit = document.getElementById('custom-form-submit');

    console.log('FormBuilder testing');
    if (!this.form) return;
    console.log('FormBuilder testing 2');
    this.form.addEventListener('submit', this.formSubmit.bind(this));
    this.querySelectorAll('.field__input-file').forEach(
      (input) => input.addEventListener('change', this.onFileInput.bind(this))
    );
  }

  onFileInput(event) {
    const input = event.target;
    const file_link = input.nextElementSibling;
    if (input.files) {
      this.form_submit.classList.add('button--loading');
      this.form_submit.disabled = true;

      const file = input.files[0];
      const formData = new FormData();
      formData.append('file', file);
      formData.append('document', this.form_submit.dataset.source);

      var res = Array.from(formData.entries(), ([key, prop]) => (
        {
          [key]: {
            "ContentLength":
              typeof prop === "string"
                ? prop.length
                : prop.size
          }
        }
      ));

      if (file.size > 5000000) {
        alert('File size too large, please reduce file size and resubmit');
        input.value = '';
      } else {

        fetch('https://hook.integromat.com/oqzsb2jqlx1spxnwnu93146brt7ex66m', {
          method: 'POST',
          body: formData
        })
          .then(response => response.text())
          .then(data => {
            file_link.value = data;
            this.form_submit.classList.remove('button--loading');
            document.getElementById('custom-form-submit').disabled = false;
          })
          .catch((error) => {
            this.form_submit.classList.remove('button--loading');
            document.getElementById('custom-form-submit').disabled = false;
          });

      }
    }
  }

  formSubmit(event) {
    event.preventDefault();
    console.log('formSubmit test');
    this.form_submit.classList.add('animate');
    let redirect_url;
    if (this.hasAttribute('data-redirect')) {
      redirect_url = this.dataset.redirect;
    }
    fetch(this.dataset.send, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: serializeJSON(this.form)
    })
      .then(response => response.json())
      .then(data => {
        this.form_submit.classList.remove('animate');
        this.form_submit.classList.add('success');
        setTimeout(function () {
          this.form.classList.add('hidden');
          this.thanks.classList.remove('hidden');
          this.thanks.scrollIntoView();
          if (typeof redirect_url !== 'undefined') {
            setTimeout(function () {
              window.location.href = redirect_url;
            }, 500);
          }
        }.bind(this), 500);
      })
      .catch((error) => {
        // console.error('Error:', error);
        this.form_submit.classList.remove('animate');
        this.form_submit.classList.add('error');
      });
  }
}

customElements.define('form-builder', FormBuilder)

class ApplyProcode extends HTMLElement {
  constructor() {
    super();
    this.applyButton = document.getElementById('pro-apply');
    this.procodeButton = document.getElementById('pro-code');
    this.procodeForm = document.getElementById('pro-code--form');
    this.container = document.getElementById('procode');

    this.applyButton.addEventListener('click', () => {
      this.container.classList.add('hidden');
    });

    this.procodeButton.addEventListener('click', () => {
      this.procodeForm.classList.remove('hidden');
    });

    this.procodeForm.addEventListener('submit', this.procodeCheck.bind(this));
  }

  procodeCheck(event) {
    event.preventDefault();
    const form = event.target;
    const form_submit = form.querySelector('button');
    let redirect_url;
    if (this.hasAttribute('data-redirect')) {
      redirect_url = this.dataset.redirect;
    }
    form_submit.disabled = true;
    form_submit.classList.add('button--loading');
    fetch('https://hook.integromat.com/3la5j88191a64rf24br5x37jb5r4re4u', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: serializeJSON(form)
    })
      .then(response => response.json())
      .then(data => {
        form_submit.disabled = false;
        form_submit.classList.remove('button--loading');
        var form_error = document.getElementById('form_error');
        if (!form_error) {
          form_error = document.createElement('div');
          form_error.id = 'form_error';
          form_submit.parentNode.insertBefore(form_error, form_submit.nextSibling);
        }
        if (data.success) {
          if (typeof redirect_url !== 'undefined') {
            setTimeout(function () {
              window.location.href = redirect_url;
            }, 500);
          }
        } else {
          form_error.innerText = data.reason;
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }
}

customElements.define('apply-procode', ApplyProcode)

class CreateLogin extends HTMLElement {
  constructor() {
    super();
    this.signUpButton = document.getElementById('signUp');
    this.signUpButton2 = document.getElementById('signUp2');
    this.signInButton = document.getElementById('signIn');
    this.signInButton2 = document.getElementById('signIn2');
    this.container = document.getElementById('create-login--container');

    this.signUpButton.addEventListener('click', () => {
      this.container.classList.add('right-panel-active');
    });

    this.signUpButton2.addEventListener('click', () => {
      this.container.classList.add('right-panel-active');
    });

    this.signInButton.addEventListener('click', () => {
      this.container.classList.remove('right-panel-active');
    });

    this.signInButton2.addEventListener('click', () => {
      this.container.classList.remove('right-panel-active');
    });

    this.accountForm = document.getElementById('create-login--container');
    this.delayedLogin = document.getElementById('delayedlogin');

    this.accountForm.querySelectorAll('form').forEach(
      (form) => form.addEventListener('submit', this.onSubmit.bind(this))
    );
  }

  onSubmit(event) {
    event.preventDefault();
    const form = event.target;
    const form_submit = form.querySelector('button');
    form_submit.disabled = true;
    form_submit.classList.add('button--loading');
    fetch('https://hook.integromat.com/3la5j88191a64rf24br5x37jb5r4re4u', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: serializeJSON(form)
    })
      .then(response => response.json())
      .then(data => {
        if (data.exists) {
          const formObject = {};
          const formData = new FormData(form);
          formData.forEach((value, key) => formObject[key] = value);
          this.delayedLogin.querySelector('#Email_Delayed').value = formObject['customer[email]'];
          this.delayedLogin.querySelector('#Password_Delayed').value = formObject['customer[password]'];
          this.delayedLogin.submit();
        } else if (data.created) {
          this.accountForm.classList.add('hidden');
          document.getElementById('applicant-email').value = formObject['customer[email]'];
        } else if (!data.exists || !data.created) {
          form.nextElementSibling.classList.remove('hidden');
          form_submit.disabled = false;
          form_submit.classList.remove('button--loading');
          if (!data.created) {
            form.nextElementSibling.querySelector('b').innerHTML = data.reason;
          }
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }
}

customElements.define('create-login', CreateLogin)

class StatementAccordion extends HTMLElement {
  constructor() {
    super();
    this.accordionBtns = this.querySelectorAll('.open_statements');

    this.accordionBtns.forEach((accordion) => {
      accordion.addEventListener('click', this.toggleAccordion.bind(this));
    });
  }

  toggleAccordion(event) {
    event.preventDefault();

    let contentID = event.target.getAttribute('data-statement');
    let content = document.getElementById(contentID);

    if (content.style.maxHeight) {
      content.style.maxHeight = null;
    } else {
      content.style.maxHeight = content.scrollHeight + "px";
    }
  }
}

customElements.define('statement-accordion', StatementAccordion);

function scrollTo(element, to, duration) {
  window.scroll({
    behavior: 'smooth',
    left: 0,
    top: to - 50
  });
}

// const anchors = document.getElementsByTagName('a');
// for (var i = 0, length = anchors.length; i < length; i++) {
//   var anchor = anchors[i];
//   if(/^#/.test(anchor.getAttribute('href'))) {
//     anchor.addEventListener('click', function(e) {
//       e.preventDefault();
//       let in_page = this.getAttribute('href');
//       let elmnt = document.getElementById(in_page.replace('#',''));
//       scrollTo(elmnt, elmnt.offsetTop, 600);
//     }, true);
//   }
// };

class CollectionSlider extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('.grid--collection_slider');
    this.sliderItems = this.querySelectorAll('.grid__item_collection');

    if (!this.slider || this.sliderItems.length < 2) return;

    new Glider(this.slider, {
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: {
        prev: '.glider-prev',
        next: '.glider-next'
      }
    });
  }
}

customElements.define('collection-slider', CollectionSlider);

function colorSwitch(e) {
  e = window.event || e;
  let target = e.target;
  let mainImg = this.querySelector('.card-mainimg');
  if (target.classList.contains('card-variant')) {
    e.preventDefault();
    let id = target.dataset.id;
    let href = this.href;
    let hrefSplit = href.split('?');
    let combinator = '';
    let elems = this.querySelectorAll('.grid__item');
    [].forEach.call(elems, function (el) {
      el.classList.remove('current');
    });
    target.closest('.grid__item').classList.add('current');
    if (hrefSplit[1] !== undefined) {
      combinator = '&';
    }
    let newHref = hrefSplit[0] + '?variant=' + id + combinator + hrefSplit[1];
    this.setAttribute('href', newHref);
    let ogSrc = this.src;
    let targetSrc = target.src;
    if (ogSrc != targetSrc) {
      let targetSrcset = target.srcset;
      let targetAlt = target.getAttribute('alt');
      mainImg.setAttribute('src', targetSrc);
      mainImg.setAttribute('srcset', targetSrcset);
      mainImg.setAttribute('alt', targetAlt);
    }
  }
}

const grid_items = document.querySelectorAll('.card-link');

function click_alter(grid_items) {
  for (var i = 0, length = grid_items.length; i < length; i++) {
    var grid_item = grid_items[i];
    grid_item.addEventListener('click', colorSwitch);
  }
}

function remove_click_alter(grid_items) {
  for (var i = 0, length = grid_items.length; i < length; i++) {
    var grid_item = grid_items[i];
    grid_item.removeEventListener('click', colorSwitch);
  }
}

if (grid_items.length > 0) {
  click_alter(grid_items);
}

$('body').on('click', 'variant-radios .product-form__input[data-option="option1"] label,variant-radios .product-form__input[data-option="option2"] label', function () {
  setTimeout(function () {
    if (!$('variant-radios .product-form__input[data-option="option3"] input:checked').hasClass('activeVariant-input')) {
      //$('variant-radios .product-form__input .activeVariant').eq(0).trigger('click');
    }
  }, 100)
})
document.querySelector('.icon--help').addEventListener('click', () => {
  console.log('tesing')
  const mobilenavs = document.querySelector('.header-nav-container');
  mobilenavs.classList.add('nav-open');
});